import Vue from "vue";
import Vuetify from "vuetify";
import colors from "vuetify/es5/util/colors";
import "vuetify/dist/vuetify.min.css";
import goTo from "vuetify/es5/services/goto";

Vue.use(Vuetify);

const vuetify = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: colors.orange.base,
        secondary: colors.amber.base,
        accent: colors.blue.accent2,
        error: colors.deepOrange.base,
        warning: colors.yellow.accent4,
        info: colors.grey.lighten1,
        success: colors.green.darken1
      }
    }
  },
  icons: {
    iconfont: "mdiSvg"
  }
});
goTo.framework = vuetify.framework;

export default vuetify;
// import Vue from "vue";
// import Vuetify from "vuetify/lib";
// import "vuetify/dist/vuetify.min.css";
// import colors from "vuetify/es5/util/colors";

// Vue.use(Vuetify, {
//   theme: {
//     primary: colors.orange.base,
//     secondary: colors.amber.base,
//     accent: colors.blue.accent2,
//     error: colors.deepOrange.base,
//     warning: colors.yellow.accent4,
//     info: colors.grey.lighten1,
//     success: colors.green.darken1
//   }
// });
